import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.375 6.75h-1.5V12h1.5V6.75zm4.5 0h-1.5V12h1.5V6.75zm6.375 6.75H0V15h14.25v-1.5zm-1.875-6.75h-1.5V12h1.5V6.75zm-5.25-5.055l3.908 2.055H3.217l3.908-2.055zm0-1.695L0 3.75v1.5h14.25v-1.5L7.125 0z" fill="#444" /></svg>;